<template>
  <div>
    <!-- 售后退款 -->
    <el-dialog
      title="售后退款"
      width="500px"
      center
      custom-class="refundAfterSale-dia"
      :visible.sync="refundAfterSaleDia"
      :before-close="close"
    >
      <div class="dialogbox">
        <div class="infobox">
          <div class="infoitem">
            <span style="color: #666">订单编号：</span>
            <span>{{ refund_data.order_sn }}</span>
          </div>
          <div class="infoitem">
            <span style="color: #666">支付时间：</span>
            <span>{{ refund_data.create_time }}</span>
          </div>
          <div class="infoitem">
            <span style="color: #666">患者：</span>
            <span>{{ refund_data.user_name }}</span>
          </div>
          <div class="infoitem">
            <span style="color: #666">医生：</span>
            <span>{{ refund_data.doctor_name }}</span>
          </div>
        </div>
        <div style="padding: 10px; background: #e9e9e9">
          <div>
            <span style="color: #666">订单金额：</span>
            <span>{{ refund_data.pay_money }}</span>
          </div>
          <div class="pricebox">
            <div>
              <span style="color: #666">药品金额：</span>
              <span>{{
                refund_data.drug_price ||
                refund_data.pm_price ||
                refund_data.ointment_price
              }}</span>
            </div>
            <div>
              <span style="color: #666">诊后管理费：</span>
              <span>{{ refund_data.consult_drug_price }}</span>
            </div>
            <div>
              <span style="color: #666">诊金：</span>
              <span>{{ refund_data.consulting_gold }}</span>
            </div>
            <div>
              <span style="color: #666">优惠金额：</span>
              <span>-{{ refund_data.discount_price }}</span>
            </div>
            <div>
              <span style="color: #666">礼品卡金额：</span>
              <span>-{{ refund_data.gift_money }}</span>
            </div>
            <div>
              <span style="color: #666">运费：</span>
              <span>{{ refund_data.freight_price }}</span>
            </div>
            <div v-if="Number(refund_data.drug_machining_price)">
              <span style="color: #666">加工费：</span>
              <span>{{ refund_data.drug_machining_price }}</span>
            </div>
            <div v-if="Number(refund_data.drug_machining_price)">
              <span style="color: #666">辅料费：</span>
              <span>{{ refund_data.excipients_price }}</span>
            </div>
          </div>
        </div>
        <div class="align-center" style="margin: 10px 0 20px">
          <span class="searchtitle">退款原因</span>
          <el-select
            v-model="refundReason"
            placeholder="请选择"
            size="medium"
            style="margin-left: 10px; width: 300px"
            @change="changeReason"
          >
            <el-option
              v-for="item in reasonOptions"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </div>
        <div style="margin-top: 10px">
          <span class="searchtitle">售后退款</span>
          <el-input-number
            v-model="price"
            :min="0"
            :max="Number(refund_data.already_price)"
            :precision="2"
            label="描述文字"
            :controls="false"
            style="margin-left: 10px; width: 300px"
            size="medium"
          ></el-input-number>
        </div>

        <div style="color: #ff9000; font-size: 12px; padding-left: 70px">
          最大退款金额：{{ refund_data.already_price }}
        </div>

        <div class="align-center" style="margin: 10px 0 20px">
          <span class="searchtitle">备注</span>
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入"
            v-model="remark"
            maxlength="50"
            style="width: 300px; margin-left: 10px"
          >
          </el-input>
        </div>
        <div
          class="align-center"
          style="margin: 10px 0 5px"
          v-if="refundReason == '退运费' ? is_show : true"
        >
          <span class="searchtitle">验证码</span>
          <el-input
            v-model="authCode"
            size="medium"
            style="margin-left: 10px; width: 200px"
            placeholder="请输入"
          ></el-input>
          <el-button
            size="medium"
            style="margin-left: 10px"
            @click="getCode(1)"
            >{{ codeText }}</el-button
          >
        </div>
        <div
          style="padding-left: 70px; color: #ff9000"
          v-if="refundReason == '退运费' ? is_show : true"
        >
          验证码有效时间3分钟
        </div>
        <div style="text-align: right">
          <el-button plain @click="close" size="medium">取消</el-button>
          <el-button
            type="primary"
            :loading="isRefundOrder"
            @click="afterRefund"
            size="medium"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import common from "@/api/common.js";
import order from "@/api/order";
export default {
  props: {
    refundAfterSaleDia: {
      type: Boolean,
      require: true,
    },
    detail: {
      type: Object,
      require: true,
    },
  },

  data() {
    return {
      refundReason: "退全额",
      abnormalReason: "退全额",
      reasonOptions: [
        {
          label: "退药费",
          value: 0,
        },
        {
          label: "退运费",
          value: 1,
        },
        {
          label: "退全额",
          value: 2,
        },
        {
          label: "退加工费",
          value: 3,
        },
        {
          label: "诊后管理费",
          value: 4,
        },
        {
          label: "诊金",
          value: 5,
        },
      ],
      authCode: "",
      codeText: "获取验证码",
      timer: null,
      isRefundOrder: false,
      price: undefined,
      remark: "",
      is_show: 0,
      refund_data: {},
    };
  },
  watch: {
    refundAfterSaleDia: {
      handler: function (n) {
        if (n) {
          this.refund_data = JSON.parse(JSON.stringify(this.detail));
          this.isShowFn();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  methods: {
    //是否显示验证码
    isShowFn() {
      let order_id = this.refund_data.order_id;
      this.axios
        .post("platform/order/getRefundConfigInfo", { order_id, path: 2 })
        .then((res) => {
          if (res.code == 0) {
            this.is_show = res.data.is_show;
          }
        });
      this.axios
        .post("platform/order/getRefundData", { order_id })
        .then((res) => {
          if (res.code == 0) {
            let data = res.data;
            if (data.refund_count) {
              this.$confirm(
                `当前订单已售后退款${data.refund_count}次，已退金额${data.refund_money}元，剩余可退金额${data.refund_surplus_money}元，是否继续售后退款？`,
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                }
              )
                .then(() => {
                  this.axios
                    .post("platform/order/getOrderInfo", { order_id })
                    .then((res) => {
                      if (res.code == 0) {
                        this.refund_data = res.data.info;
                        this.refund_data.create_time = dayjs
                          .unix(this.refund_data.create_time)
                          .format("YYYY-MM-DD HH:mm:ss");
                        this.remark = "";
                        this.price = "";
                      }
                    });
                })
                .catch(() => {});
            } else {
              this.axios
                .post("platform/order/getOrderInfo", { order_id })
                .then((res) => {
                  if (res.code == 0) {
                    this.refund_data = res.data.info;
                    this.refund_data.create_time = dayjs
                      .unix(this.refund_data.create_time)
                      .format("YYYY-MM-DD HH:mm:ss");
                    this.remark = "";
                    this.price = "";
                  }
                });
            }
          }
        });
    },
    //修改售后退款原因
    changeReason(value) {
      this.price = "";
      let data = {
        order_id: this.refund_data.order_id,
        type_name: value,
      };
      this.axios.post("platform/order/getRefundData", data).then((res) => {
        if (res.code == 0) {
          this.refund_data.already_price = res.data.refund_max_money;
        }
      });
    },
    //售后退款
    afterRefund() {
      if (!this.price || !this.remark) {
        this.$message.error("请完善退款信息");
        return false;
      }
      this.isRefundOrder = true;
      let order_id = this.refund_data.order_id;
      this.axios
        .post("platform/order/getRefundData", { order_id })
        .then((res) => {
          if (res.code == 0) {
            let data = res.data;
            if (data.refund_count) {
              this.$confirm(
                `当前订单已售后退款${data.refund_count}次，已退金额${data.refund_money}元，剩余可退金额${data.refund_surplus_money}元，是否继续售后退款？`,
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                }
              )
                .then(() => {
                  let data = {
                    id: this.$route.query.id,
                    order_id: this.refund_data.order_id,
                    remark: this.remark,
                    price: this.price,
                    code: this.authCode,
                    refund_desc: this.refundReason,
                  };
                  common
                    .saveOrderServiceAfterRefund(data)
                    .then((res) => {
                      if (res.code == 0) {
                        this.$message.success("退款成功");
                        this.restCode();
                        this.remark = "";
                        this.authCode = "";
                        this.$emit("comfirmRefundAfterSale");
                        this.close();
                      } else {
                        this.$message.error(res.message);
                      }
                      this.isRefundOrder = false;
                    })
                    .catch((err) => {
                      this.isRefundOrder = false;
                      this.close();
                    });
                })
                .catch(() => {
                  this.isRefundOrder = false;
                });
            } else {
              let data = {
                id: this.$route.query.id,
                order_id: this.refund_data.order_id,
                remark: this.remark,
                price: this.price,
                code: this.authCode,
                refund_desc: this.refundReason,
              };
              common
                .saveOrderServiceAfterRefund(data)
                .then((res) => {
                  if (res.code == 0) {
                    this.$message.success("退款成功");
                    this.isRefundOrder = false;
                    this.restCode();
                    this.authCode = "";
                    this.remark = "";
                    this.reasonType = "";
                    this.$emit("comfirmRefundAfterSale");
                    this.close();
                  }
                })
                .catch((err) => {
                  this.isRefundOrder = false;
                });
            }
          }
        });
    },
    close() {
      this.$emit("update:refundAfterSaleDia", false);
    },
    // 获取验证码
    getCode: _.throttle(
      function () {
        if (!this.codeText.includes("获")) {
          this.$message.warning("验证码已发送");
          return;
        }
        let params = {};
        if (this.remark == "") {
          this.$message.warning("请填写完内容");
          return;
        }
        if (this.price <= 0) {
          this.$message.warning("金额要大于0");
          return;
        }
        params = {
          order_id: this.refund_data.order_id,
          price: this.price,
          refund_desc: this.refundReason,
        };
        order.refundVerifiCode(params).then((res) => {
          let { code } = res;
          if (code === 0) {
            this.$message.success("发送成功");
            let time = 60;
            this.timer = window.setInterval(() => {
              if (!time) {
                this.restCode();
                return;
              }
              time -= 1;
              this.codeText = `${time}S`;
            }, 1000);
            this.$once("hook:beforeDestroy", function () {
              this.restCode();
            });
          }
        });
      },
      5000,
      { trailing: false }
    ),
    // 重置验证码
    restCode() {
      window.clearInterval(this.timer);
      this.codeText = "获取验证码";
    },
  },
};
</script>

<style lang="scss">
.refundAfterSale-dia {
  .dialogbox {
    padding: 16px;
    .infobox {
      display: flex;
      flex-wrap: wrap;
      .infoitem {
        width: 50%;
        margin-bottom: 12px;
      }
    }
    .pricebox {
      display: flex;
      flex-wrap: wrap;
      div {
        width: 33.33%;
        margin-top: 5px;
      }
    }
  }
  .searchtitle {
    display: inline-block;
    width: 100px;
    text-align: right;
    box-sizing: border-box;
  }
}
</style>
